import type { HelpFile } from '../../types/help'
import { RestrictionRuleRequestCreateWizardTestIds } from '../../../testids/RestrictionRuleRequestCreateWizardTestIds'

export const restrictionRuleRequestCreateWizardHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rule-requests',
  texts: {
    [RestrictionRuleRequestCreateWizardTestIds.inputName]:
      'Unique name for this restriction rule — identifies the request in the approval workflow.',
    [RestrictionRuleRequestCreateWizardTestIds.graceDaysPicker]:
      'Days before violations are cleared after deactivation — gives affected identities time to revoke denied profiles.',
    [RestrictionRuleRequestCreateWizardTestIds.inputConditionExpr]:
      'CEL expression that selects which identities this rule applies to.',
    [RestrictionRuleRequestCreateWizardTestIds.btnToggleHelp]:
      'Show or hide CEL syntax reference.',
    [RestrictionRuleRequestCreateWizardTestIds.btnRunTest]:
      'Run the condition against all current identities to preview matches and violations.',
    [RestrictionRuleRequestCreateWizardTestIds.testResultsSuccess]:
      'Test run summary — identities evaluated, matched, and in violation.',
    [RestrictionRuleRequestCreateWizardTestIds.profileModeToggle]:
      'Switch between selecting denied profiles from a list or by condition expression.',
    [RestrictionRuleRequestCreateWizardTestIds.inputProfileSearch]:
      'Search for access profiles to add to the denied list.',
    [RestrictionRuleRequestCreateWizardTestIds.inputProfileCondition]:
      'CEL expression matching access profiles to deny — identities holding any matched profile are in violation.',
    [RestrictionRuleRequestCreateWizardTestIds.reviewTestSummary]:
      'Summary of the most recent test run against current identities.',
    [RestrictionRuleRequestCreateWizardTestIds.btnSubmit]:
      'Submit for approval — cannot be edited once submitted.',
    [RestrictionRuleRequestCreateWizardTestIds.btnSkipTest]:
      'Skip testing — the request can still be submitted, but reviewers will see "not tested".',
    [RestrictionRuleRequestCreateWizardTestIds.btnAbandonConfirm]:
      'Discard this draft and leave the wizard — unsaved changes are lost.',
    [RestrictionRuleRequestCreateWizardTestIds.btnAbandonStay]:
      'Stay in the wizard and keep editing.',
    [RestrictionRuleRequestCreateWizardTestIds.abandonDialogTitle]:
      'Confirm whether to discard the unsaved draft.',
    [RestrictionRuleRequestCreateWizardTestIds.conditionEmptyWarning]:
      'No identity condition set — the rule will apply to every identity if submitted as-is.',
    [RestrictionRuleRequestCreateWizardTestIds.noProfilesSelected]:
      'No denied profiles selected yet — add at least one profile or condition before continuing.',
    [RestrictionRuleRequestCreateWizardTestIds.notTestedNote]:
      'Not tested before submission — reviewers can still approve but the impact is unknown.',
    [RestrictionRuleRequestCreateWizardTestIds.selectedProfilesList]:
      'Access profiles currently denied by this rule — identities holding any of these are in violation.',
    [RestrictionRuleRequestCreateWizardTestIds.inputDescription]: null,
    [RestrictionRuleRequestCreateWizardTestIds.btnPreviousStep]: null,
    [RestrictionRuleRequestCreateWizardTestIds.btnNextStep]: null,
    [RestrictionRuleRequestCreateWizardTestIds.errorName]: null,
    [RestrictionRuleRequestCreateWizardTestIds.errorOwner]: null,
    [RestrictionRuleRequestCreateWizardTestIds.btnProfileModeCondition]: null,
    [RestrictionRuleRequestCreateWizardTestIds.btnProfileModeList]: null,
    [RestrictionRuleRequestCreateWizardTestIds.btnViewAffected]: null,
    [RestrictionRuleRequestCreateWizardTestIds.expressionValidating]:
      'The CEL expression is being validated by the in-browser CEL engine.',
    [RestrictionRuleRequestCreateWizardTestIds.expressionValidIndicator]:
      'The CEL expression is syntactically valid.',
    [RestrictionRuleRequestCreateWizardTestIds.expressionInvalidIndicator]:
      'The CEL expression has parse errors. The line/column indicator points at the first failure.',
    [RestrictionRuleRequestCreateWizardTestIds.expressionNetworkError]:
      'Validation failed because the backend was unreachable. The expression itself may still be valid — submit will re-validate.',
    [RestrictionRuleRequestCreateWizardTestIds.pageRestrictionRuleRequestCreateWizard]: null,
    [RestrictionRuleRequestCreateWizardTestIds.restrictionRuleRequestStepContainer]: null,
    [RestrictionRuleRequestCreateWizardTestIds.thTestResultIdentity]: null,
    [RestrictionRuleRequestCreateWizardTestIds.thTestResultOwner]: null,
  },
}
